import { PublicClientApplication, Configuration, AuthenticationResult } from '@azure/msal-browser'

/**
 * AZURE auth settings
 */
// Default values - to be used for testing in dev:
let CLIENT_ID = '4350bc14-468f-460e-8d3e-71ee2fc0f0f7'
const TENANT_ID = '41360c96-1755-4bf8-8527-81bb0ad2ac43'

// Prod values
const URL = window.location.href
if (URL.includes('sp.chorus.co.nz')) {
  CLIENT_ID = '33913f00-22c2-464d-b78b-d00970912a8f'
}

const msalConfig: Configuration = {
  auth: {
    clientId: CLIENT_ID,
    authority: `https://login.microsoftonline.com/${TENANT_ID}/`,
    redirectUri: `${window.location.protocol}//${window.location.hostname}`
  },
  cache: {
    cacheLocation: 'localStorage', // This configures where your cache will be stored
    storeAuthStateInCookie: false // Set this to 'true' if you are having issues on IE11 or Edge
  }
}

const loginRequest = {
  scopes: ['openid', 'profile', 'User.Read', 'email']
}

const myMSALObj = new PublicClientApplication(msalConfig)

const buttonsWrapperElements = document.querySelectorAll('.sp-login-form #user-login-form #edit-actions, .sp-login-form #user-login-form--2 #edit-actions--2, .login-popup__azure_button')

function createSpinnerEl (): HTMLElement {
  const spinner = document.createElement('div')
  spinner.className = 'sp-loader'
  return spinner
}

if (buttonsWrapperElements.length > 0) {
  buttonsWrapperElements.forEach(buttonsWrapperEl => {
    const loginLink = document.createElement('a')
    loginLink.href = '#'
    loginLink.id = 'azure-sso-btn'
    loginLink.className = 'button js-form-submit form-submit btn btn-primary'
    loginLink.textContent = 'Azure Login'

    buttonsWrapperEl.setAttribute('style', 'display: flex; justify-items: flex-start; justify-content: space-between;')
    buttonsWrapperEl.appendChild(loginLink)

    loginLink.addEventListener('click', (e) => {
      e.preventDefault()
      myMSALObj.loginPopup(loginRequest).then((response: AuthenticationResult) => {
        const currentUrl = window.location.href
        const pathname = window.location.pathname

        if (currentUrl.includes('/user/login')) {
          // Show spinner instead of the form inside the page
          const form = document.querySelector('main#content .section.sp-login-form form.user-login-form') as HTMLElement
          const formContainer = document.querySelector('main#content .section.sp-login-form') as HTMLElement
          if (form && formContainer) {
            // Hide form content and show spinner
            form.style.display = 'none'

            formContainer.appendChild(createSpinnerEl())
          }
        }

        // Show spinner instead of the form inside popup
        const popupEl = document.querySelector('header#header .login-popup__panel') as HTMLElement
        // Hide login popup form and notes above it
        if (popupEl && popupEl.parentElement) {
          popupEl.style.display = 'none'
          popupEl.parentElement.appendChild(createSpinnerEl())
        }

        window.location.href = `/azure/login?token=${response.idToken}&path=${pathname}`
      }).catch((error) => {
        console.error(error)
      })
    })
  })
}

const forgotPasswordLink = document.createElement('a')
forgotPasswordLink.href = '/user/password'
forgotPasswordLink.id = 'login-popup-forgot-password'
forgotPasswordLink.textContent = 'Forgot password?'
forgotPasswordLink.setAttribute('style', 'display: block; margin: -25px 0 20px 0; font-weight: 500; font-size: 12px;')

const loginPopupFormActions = document.querySelectorAll('.login-popup__login-panel .form-actions')
if (loginPopupFormActions.length > 0) {
  loginPopupFormActions.forEach(loginPopupFormAction => {
    const parent = loginPopupFormAction.parentElement
    if (parent) {
      parent.insertBefore(forgotPasswordLink, loginPopupFormAction)
      const submitBtn = parent.querySelector('#edit-submit')
      if (submitBtn) {
        submitBtn.setAttribute('value', 'SP Login')
        submitBtn.innerHTML = 'Login'
      }
    }
  })
}
